const EvaluationTypes = {
  HIT: "HIT",
  ERROR: "ERROR",
  PARTIAL_HIT: "PARTIAL_HIT",
};

export default EvaluationTypes;
